import { AccountInfo, IPublicClientApplication } from '@azure/msal-browser'
import axios from 'axios'
import { LOGIKSPARK_USERS_API_URL } from '../../app/axios/const'
import { loginRequest } from '../../authConfig'

// Mirrors CORE's PersonaResponse (Models/Datasets/Auth) — the shape of GET /api/v1/auth/personas (E8 F8-3).
export interface Persona {
  userId: number
  tenantId: number
  tenantSubdomain: string
  tenantDisplayName: string
  customerId: number | null
  customerDisplayName: string | null
  isAccountOwner: boolean
  isTenantDirect: boolean
}

// Dedicated, INTERCEPTOR-FREE client. A bare axios.create() inherits none of the default axios
// instance's interceptors — and RequestInterceptor (an ancestor of AppShell) registers a global request
// interceptor on the default instance that re-acquires a token, throws on a null account, and can fire
// acquireTokenRedirect mid-flight. Using a clean client means the only Authorization header is the one
// acquired below, so the persona gate's fetch is genuinely self-contained and can resolve before App
// wires up its own authorized clients. The timeout sends a hung network to the gate's error screen
// rather than an indefinite spinner.
const personaClient = axios.create({ timeout: 15000 })

// Fetches the caller's personas across all their Tenants/Customers. /auth/personas is [PersonaOptional],
// so no X-LogikSpark-Persona-Id header is required (and none is set yet at this point).
export async function fetchPersonas(
  instance: IPublicClientApplication,
  account: AccountInfo,
): Promise<Persona[]> {
  const result = await instance.acquireTokenSilent({ ...loginRequest, account })
  const response = await personaClient.get<Persona[]>(`${LOGIKSPARK_USERS_API_URL}v1/auth/personas`, {
    headers: { Authorization: `Bearer ${result.accessToken}` },
  })
  return response.data
}
